import { ChangeEvent, useState } from 'react'

const ROWS_PER_PAGE_OPTIONS = [5, 10, 15, 20]
const DEFAULT_PAGE = 0
const ROWS_PER_PAGE = 5
const DEFAULT_ELEMENTS = 0

export type TableProps = {
  page: number
  totalOfElements: number
  rowsPerPage: number
  rowsOptions: number[]
  handleNewPage: (e: unknown, newPage: number) => void
  handleRowsPerPage: (e: ChangeEvent<HTMLInputElement>) => void
}

export const usePagination = () => {
  const [page, setPage] = useState(DEFAULT_PAGE)
  const [rowsPerPage, setRowsPerPage] = useState(ROWS_PER_PAGE)
  const [totalOfElements, setTotalOfElements] = useState(DEFAULT_ELEMENTS)
  const [totalOfPages, setTotalOfPages] = useState(DEFAULT_PAGE)

  const rowsOptions = ROWS_PER_PAGE_OPTIONS

  const handleNewPage = (e: unknown, newPage: number): void => setPage(newPage)

  const handleRowsPerPage = (e: ChangeEvent<HTMLInputElement>): void => {
    setRowsPerPage(+e.target.value)
    setPage(0)
  }

  const handleTotalOfElements = (totalOfElements: number): void =>
    setTotalOfElements(totalOfElements)

  const handleTotalOfPages = (totalOfPages: number): void => setTotalOfPages(totalOfPages)

  return {
    page,
    pages: {
      totalOfPages,
      handleTotalOfPages,
    },
    elements: {
      totalOfElements,
      handleTotalOfElements,
    },
    rows: { rowsPerPage, rowsOptions },
    handleNewPage,
    handleRowsPerPage,
  }
}
